import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'button-credito',
  templateUrl: './button-credito.component.html',
  styleUrls: ['./button-credito.component.css']
})
export class ButtonCreditoComponent implements OnInit {
  @Input() texto: string = 'Solicitar crédito';
  @Input() icono: string = 'assets/icons/button-circle.svg';
  @Input() iconoHovered: string = 'assets/icons/button-circle-hovered.svg';
  @Input() iconoClicked: string = 'assets/icons/button-circle-clicked.svg';
  @Output() onClick = new EventEmitter<void>();

  hovered = false;
  pressed = false;
  bgColor = '';
  textColor = '';

  ngOnInit(): void {
    this.hovered = false;
    this.pressed = false;
    this.bgColor = '';
    this.textColor = '';
  }

  setPressedColor() {
    this.pressed = true;
    this.bgColor = '#02231C';
    this.textColor = '#FFFFFF';
  }

  getIconoActual(): string {
    if (this.pressed) {
      return this.iconoClicked;
    }
    if (this.hovered) {
      return this.iconoHovered;
    }
    return this.icono;
  }

  goToPortal() {
    window.location.href = environment.portalUrl;
  }
}
